"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tags = {
    direflowEventName: 'matomo-client-event',
    payement: {
        name: 'Page paiement',
        elements: {
            readingBilling: 'Consultation dernière facture',
            subscriptionEBilling: 'Souscription à la dématérialisation en succès',
            subscriptionPeriodicDirectDebitWithEBilling: 'Souscription au prélèvement périodique avec dématérialisation en succès',
            subscriptionPeriodicDirectDebitWithEBillingSendToSaphir: 'Souscription au prélèvement périodique avec dématérialisation en succès - Envoi à Saphir',
            subscriptionPeriodicDirectDebitWithEBillingSendToNaia: 'Souscription au prélèvement périodique avec dématérialisation en succès - Envoi au CCL',
            subscriptionPeriodicDirectDebitWithoutEBilling: 'Souscription au prélèvement périodique sans dématérialisation en succès',
            subscriptionPeriodicDirectDebitWithoutEBillingSendToSaphir: 'Souscription au prélèvement périodique sans dématérialisation en succès - Envoi à Saphir',
            subscriptionPeriodicDirectDebitWithoutEBillingSendToNaia: 'Souscription au prélèvement périodique sans dématérialisation en succès - Envoi au CCL',
            downloadBilling: 'Téléchargement dernière facture',
            downloadHistoryBilling: "Téléchargement facture de l'historique",
            billingPayment: 'Paiement par carte bleue en succès',
            updateDirectDebitOption: 'Modification échéancier en succès',
            unsubscribeEBilling: 'Désinsciption à la facture Electronique'
        }
    },
    home: {
        name: "Page d'accueil",
        elements: {
            meterIndex: "Relevé d'index en succès"
        }
    },
    offline: {
        name: 'Hors connexion',
        elements: {
            forgetPassword: 'Mot de passe oublié en succès',
            identifierBlocked: 'Identifiant bloqué en succès',
            createAccount: 'Création de compte en succès',
            login: "Connexion à l'espace client",
            firstLogin: '1er connexion'
        }
    },
    offlineContractCancellation: {
        name: 'Résiliation de contrat sans connexion',
        elements: {
            identifyUser: "Identification de l'utilisateur",
            contractList: 'Lister les contracts',
            acceptRules: 'Acceptation des régles',
            readMeter: 'Relever du compteur',
            sendForms: 'Envoi de formulaire',
            cancelationConfirmation: 'Confirmation de la prise en charge de la demande'
        }
    },
    profile: {
        name: 'Page profil',
        elements: {
            unSubscribe: 'Désinscription en succès',
            identifierBlocked: 'Identifiant bloqué',
            createAccount: 'Création de compte',
            updatePhone: 'Modification du numéro de téléphone',
            updateIban: "Modification de l'iban",
            updateBillingAddress: "Modification de l'adresse de facturation",
            updateIdentifier: "Modification d'identifiant"
        }
    },
    contrat: {
        name: 'Page contrat',
        elements: {
            addContract: 'Ajout de contrat',
            removeContract: 'Résiliation de contrat en succès',
            articleLink: 'Redirection via article',
            renameContract: 'Renommer un contrat',
            downloadProof: "Télécharger l'attestation de titulaire de contrat"
        }
    },
    helpAndContact: {
        name: 'Page aide et contact',
        elements: {
            contactUsLink: 'Redirection "Nous contacter"',
            meetUsLink: 'Redirection "Nous rencontrer"'
        }
    },
    moveIn: {
        name: 'Abonnement selfcare',
        actions: {
            Step0Prerequisite: {
                name: 'Abonnement - Etape 0 : Prérequis',
                events: {
                    Step01TownEligibility: 'Abonnement - Etape 0.1 : Sélection de la commune',
                    Step011DisabledRegion: 'Abonnement - Etape 0.1.1 : Parcours non disponible pour la commune/région sélectionnée',
                    Step02PrivateOrProfessional: 'Abonnement - Etape 0.2 : Sélection du type de client',
                    Step021Disabled: 'Abonnement - Etape 0.2.1 : Parcours non disponible pour les sociétés/administrations',
                    Step03Prerequisite: 'Abonnement - Etape 0.3 : Validation des documents nécessaires'
                }
            },
            Step1AccountHolderInfos: {
                name: 'Abonnement - Etape 1 : Mes informations',
                events: {
                    Step1AccountHolderInfos: 'Abonnement - Etape 1 : Mes informations'
                }
            },
            Step2JointAccountHolderInfos: {
                name: 'Abonnement - Etape 2 : Informations du co-titulaire',
                events: {
                    Step2JointAccountHolderInfos: 'Abonnement - Etape 2 : Informations du co-titulaire'
                }
            },
            Step3MeterInfos: {
                name: 'Abonnement - Etape 3 : Mon compteur',
                events: {
                    Step3MeterInfos: 'Abonnement - Etape 3 : Mon compteur',
                    Step31UnrecoginzedMeter: 'Abonnement - Etape 3.1 : Compteur non identifié'
                }
            },
            Step4MeterAddress: {
                name: 'Abonnement - Etape 4 : Mon adresse desservie',
                events: {
                    Step4MeterAddress: 'Abonnement - Etape 4 : Mon adresse desservie'
                }
            },
            Step5BillingAddress: {
                name: 'Abonnement - Etape 5 : Mon adresse de correspondance',
                events: {
                    Step5BillingAddress: 'Abonnement - Etape 5 : Mon adresse de correspondance'
                }
            },
            Step6ConsumptionEstimation: {
                name: 'Abonnement - Etape 6 : Estimation de ma consommation',
                events: {
                    Step6ConsumptionEstimation: 'Abonnement - Etape 6 : Estimation de ma consommation',
                    Step61ConsumptionEstimationYes: 'Abonnement - Etape 6.1 : Estimation de ma consommation en m3-OUI',
                    Step62ConsumptionEstimationNo: 'Abonnement - Etape 6.2 : Estimation de ma consommation en m3-NON'
                }
            },
            Step7PaymentInfos: {
                name: 'Abonnement - Etape 7 : Ma facturation',
                events: {
                    Step7PaymentInfos: 'Abonnement - Etape 7 : Ma facturation',
                    Step71PaymentInfosDirectDebit: 'Abonnement - Etape 7.1 : Ma facturation-prélèvement mensuel',
                    Step711DirectDebitWithInvoiceDemat: 'Abonnement - Etape 7.1.1 : Dématérialisation facture avec prélèvement mensuel',
                    Step72WithdrawalOnInvoice: 'Abonnement - Etape 7.2 : Ma facturation-prélèvement sur facture',
                    Step721WithdrawalOnInvoiceWithInvoiceDemat: 'Abonnement - Etape 7.2.1 : Dématérialisation facture avec prélèvement sur facture',
                    Step73PaymentInfosOtherPaymentMethods: 'Abonnement - Etape 7.3 : Ma facturation-autres moyens de paiement'
                }
            },
            FinalStep: {
                name: 'Abonnement - Etape Finale',
                events: {
                    Recap: 'Abonnement - Etape Finale (8.1) : Récapitulatifs de mes informations',
                    Conditions: 'Abonnement - Etape Finale (8.2) : Validation des conditions',
                    ConditionsValidation: 'Abonnement - Etape Finale (8.3) : Validation des conditions - Validation + envoi en succès'
                }
            }
        }
    },
    exchange: {
        name: 'Page Mes Echanges',
        actions: {
            planAppointmentInaccessibleMeter: {
                name: 'Renouvellement de compteur inaccessible - Planifier le RDV',
                events: {
                    step1InterventionType: 'Renouvellement de compteur inaccessible - Planifier le RDV - Etape 1 - Choix du motif',
                    step2InterventionDate: 'Renouvellement de compteur inaccessible - Planifier le RDV - Etape 2 - Choix du créneau',
                    step3InterventionClientInfo: 'Renouvellement de compteur inaccessible - Planifier le RDV - Etape 3 - Saisie des informations',
                    step4Recap: 'Renouvellement de compteur inaccessible - Planifier le RDV - Etape 4 - Récapitulatif',
                    stepValidate: 'Renouvellement de compteur inaccessible - Planifier le RDV - Validation'
                }
            },
            updateAppointmentInacessibleMeter: {
                name: 'Renouvellement de compteur inaccessible - Modifier le RDV',
                events: {
                    step1InterventionType: 'Renouvellement de compteur inaccessible - Modifier le RDV - Etape 1 - Choix du motif',
                    step2InterventionDate: 'Renouvellement de compteur inaccessible - Modifier le RDV - Etape 2 - Choix du créneau',
                    step3InterventionClientInfo: 'Renouvellement de compteur inaccessible - Modifier le RDV - Etape 3 - Saisie des informations',
                    step4Recap: 'Renouvellement de compteur inaccessible - Modifier le RDV - Etape 4 - Récapitulatif',
                    stepValidate: 'Renouvellement de compteur inaccessible - Modifier le RDV - Validation'
                }
            },
            cancelAppointmentInacessibleMeter: {
                name: 'Renouvellement de compteur inaccessible - Annuler le RDV',
                events: {
                    validateCancelation: "Renouvellement de compteur inaccessible - Validation de l'annulation"
                }
            },
            showAppointmentInacessibleMeter: {
                name: "Renouvellement de compteur - Consultation du RDV (uniquement tant que l'intervention n'est pas au statut réalisé)"
            },
            consultInterventions: {
                name: 'Mes échanges - Interventions'
            },
            consultAlerts: {
                name: 'Mes échanges - Alertes'
            },
            consultRequests: {
                name: 'Mes échanges - Demandes'
            },
            multiRecipientAlerts: {
                name: 'Mes échanges - Alertes multi-destinataires',
                events: {
                    modalOpening: 'Mes échanges - Alertes multi-destinataires - Ouverture du modal pour saisir des adresses',
                    modalClosing: 'Mes échanges - Alertes multi-destinataires - Fermeture du modal (annulation)',
                    formValidation: 'Mes échanges - Alertes multi-destinataires - Validation du formulaire',
                    successStep: 'Mes échanges - Alertes multi-destinataires - Étape de réussite',
                    failureStep: "Mes échanges - Alertes multi-destinataires - Étape d'échec"
                }
            }
        }
    }
};
exports.default = tags;
